enum ProductType {
  KATALON_STUDIO = 'KATALON_STUDIO',
  TESTOPS = 'TESTOPS',
  TESTCLOUD = 'TESTCLOUD',
  VISUAL_TESTING = 'VISUAL_TESTING',
  TESTOPS_PLATFORM = 'TESTOPS_PLATFORM',
  TESTOPS_G3 = 'TESTOPS_G3',
  TRUE_TEST = 'TRUE_TEST',
  TESTOPS_G3_ADMIN = 'TESTOPS_G3_ADMIN',
  TRUE_PLATFORM = 'TRUE_PLATFORM',
}

const selfServeProducts: ProductType[] = [
  ProductType.KATALON_STUDIO,
  ProductType.TESTOPS,
  ProductType.TESTCLOUD,
  ProductType.VISUAL_TESTING,
  ProductType.TESTOPS_PLATFORM,
];

const enterpriseProducts: ProductType[] = [
  ProductType.TESTOPS_G3,
  ProductType.TRUE_TEST,
];

function isSelfServeProduct(productType: ProductType): boolean {
  return selfServeProducts.includes(productType);
}

function isEnterpriseProduct(productType: ProductType): boolean {
  return enterpriseProducts.includes(productType);
}

export {
  ProductType,
  selfServeProducts,
  enterpriseProducts,
  isSelfServeProduct,
  isEnterpriseProduct,
};
